<template>
    <div class="location-item">
        <div class="location-text-context">
            <div class="location-title">
                {{loca.name}}
            </div>
            <div class="location-open" :class="{locationClosed: !loca.opening_hours.open_now}">
                {{openMessage(loca.opening_hours)}}
            </div>
        </div>
        <div class="location-rating">
            {{loca.rating}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "LocationCard",
        props: ["loca"],
        methods: {
            openMessage(opening_hours) {
                return opening_hours.open_now ? "Open" : "Closed"
            }
        }
    }
</script>

<style scoped>
    .location-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        animation-duration: 0.3s;


        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        border-bottom: 1px solid #ddd; /* Add a thin border to each list item */
        border-top: 1px solid #ddd;
        margin-top: -1px; /* Prevent double borders */
        background-color: #f6f6f6; /* Add a grey background color */
        /*padding: 12px; !* Add some padding *!*/

        cursor: pointer;
        box-sizing: border-box;
        min-height: 112px;
        padding: 10px 18px 10px 24px;

        z-index: 0;
    }

    .location-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .location-open {
        font-size: 12px;
    }

    .location-rating {
    }

    .location-open {
        font-size: 12px;
    }

    .locationClosed {
        color: red;
    }
</style>